var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#fold_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.785 18.805a1 1 0 0 0 .882.528H15a1 1 0 0 0 .832-.445l3.333-5a1 1 0 0 0 .037-1.05L16.151 7.5l3.05-5.337a1 1 0 0 0-.869-1.496H5a1 1 0 0 0-.868.504L.798 7.004a1 1 0 0 0 0 .992l3.027 5.297-2.99 4.486a1 1 0 0 0-.05 1.026m4.795-6.472L3.39 8.5h11.03l2.19 3.833zm10.885 2-2 3H3.535l2-3zM14.42 6.5H3.39l2.19-3.833h11.03z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "fold_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgFold.displayName = "SvgFold";
export { SvgFold as ReactComponent };
export default SvgFold;